import PausedProgramSubscription from './PausedProgramSubscription';

export default PausedProgramSubscription;
